var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { title: _vm.title } },
    [
      _c("sc-grid", {
        ref: "form",
        attrs: {
          data: _vm.invoices,
          total: _vm.invoices.length,
          loading: _vm.loading,
          rules: _vm.rules,
          "default-filters": _vm.defaultFilters,
          "has-backend-sorting": false
        },
        on: { submit: _vm.getInvoices },
        scopedSlots: _vm._u([
          {
            key: "filters",
            fn: function(ref) {
              var filters = ref.filters
              return [
                _c("div", { staticClass: "columns" }, [
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: "Tipo de fatura",
                            prop: "invoice_type"
                          }
                        },
                        [
                          _c(
                            "sc-select",
                            {
                              attrs: { expanded: "" },
                              on: {
                                input: function($event) {
                                  _vm.setCurrentInvoiceType(
                                    filters.invoice_type
                                  )
                                }
                              },
                              model: {
                                value: filters.invoice_type,
                                callback: function($$v) {
                                  _vm.$set(filters, "invoice_type", $$v)
                                },
                                expression: "filters.invoice_type"
                              }
                            },
                            [
                              _c(
                                "option",
                                { attrs: { selected: "", value: "INVOICE" } },
                                [_vm._v("Fatura")]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                { attrs: { value: "PRE_INVOICE" } },
                                [_vm._v("Pré-fatura")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: _vm.currentInvoiceType.label,
                            prop: "invoice_numbers"
                          }
                        },
                        [
                          _c("sc-taginput", {
                            attrs: {
                              placeholder: "Informe um ou mais valores",
                              "on-paste-separators": [",", " "],
                              maxtags: 500
                            },
                            model: {
                              value: filters.invoice_numbers,
                              callback: function($$v) {
                                _vm.$set(filters, "invoice_numbers", $$v)
                              },
                              expression: "filters.invoice_numbers"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: "Buscar periodo por",
                            prop: "date_range_type"
                          }
                        },
                        [
                          _c(
                            "sc-select",
                            {
                              attrs: { expanded: "" },
                              model: {
                                value: filters.date_range_type,
                                callback: function($$v) {
                                  _vm.$set(filters, "date_range_type", $$v)
                                },
                                expression: "filters.date_range_type"
                              }
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: { selected: "", value: "GENERATION" }
                                },
                                [_vm._v("Data de geração")]
                              ),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "EXPIRATION" } }, [
                                _vm._v("Data de expiração")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        { attrs: { label: "Período", prop: "date_range" } },
                        [
                          _c("sc-range-date-picker", {
                            model: {
                              value: filters.date_range,
                              callback: function($$v) {
                                _vm.$set(filters, "date_range", $$v)
                              },
                              expression: "filters.date_range"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "columns" }, [
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: "Transportadora",
                            prop: "logistic_providers"
                          }
                        },
                        [
                          _c("sc-logistic-provider-dropdown", {
                            attrs: { dropdown: "" },
                            on: {
                              selectAll: function(values) {
                                return (filters.logistic_providers = values)
                              },
                              clearFilter: function() {
                                return (filters.logistic_providers = [])
                              }
                            },
                            model: {
                              value: filters.logistic_providers,
                              callback: function($$v) {
                                _vm.$set(filters, "logistic_providers", $$v)
                              },
                              expression: "filters.logistic_providers"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        { attrs: { label: "Buscar por", prop: "search_by" } },
                        [
                          _c(
                            "sc-select",
                            {
                              attrs: { expanded: "" },
                              on: {
                                input: function($event) {
                                  _vm.setCurrentSearch(filters.search_by)
                                }
                              },
                              model: {
                                value: filters.search_by,
                                callback: function($$v) {
                                  _vm.$set(filters, "search_by", $$v)
                                },
                                expression: "filters.search_by"
                              }
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: { selected: "", value: "ORDER_NUMBER" }
                                },
                                [_vm._v("Pedido")]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                { attrs: { value: "INVOICE_NUMBER" } },
                                [_vm._v("Nota Fiscal")]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                { attrs: { value: "INVOICE_KEY" } },
                                [_vm._v("Chave de acesso da NF")]
                              ),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "CTE_NUMBER" } }, [
                                _vm._v("CTe")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "CTE_KEY" } }, [
                                _vm._v("Chave de acesso do CTe")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: _vm.currentSearch.label,
                            prop: "search_values"
                          }
                        },
                        [
                          _c("sc-taginput", {
                            attrs: {
                              placeholder: "Informe um ou mais valores",
                              "on-paste-separators": [",", " "],
                              maxtags: 500
                            },
                            model: {
                              value: filters.search_values,
                              callback: function($$v) {
                                _vm.$set(filters, "search_values", $$v)
                              },
                              expression: "filters.search_values"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "filters-actions",
            fn: function(ref) {
              var filters = ref.filters
              var isValid = ref.isValid
              return [
                _c("sc-button", {
                  attrs: {
                    text: "Exportar para o Excel",
                    loading: _vm.loadingExports,
                    disabled: !isValid
                  },
                  on: {
                    click: function($event) {
                      _vm.callExportToExcel(filters)
                    }
                  }
                }),
                _vm._v(" "),
                _c("sc-button", {
                  attrs: {
                    text: "Gerar Espelho da Fatura",
                    loading: _vm.loadingInvoice,
                    disabled: !isValid
                  },
                  on: {
                    click: function($event) {
                      _vm.generateInvoiceMirror(filters)
                    }
                  }
                }),
                _vm._v(" "),
                _c("sc-button", {
                  attrs: { type: "button", text: "Limpar filtros" },
                  on: { click: _vm.clearFilters }
                }),
                _vm._v(" "),
                _c("sc-button", {
                  attrs: {
                    type: "submit",
                    theme: "primary",
                    text: "Buscar",
                    loading: _vm.loading
                  }
                })
              ]
            }
          },
          {
            key: "table-columns",
            fn: function(ref) {
              var props = ref.props
              return [
                _c(
                  "sc-table-column",
                  { attrs: { label: "ID", field: "id", sortable: "" } },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "sc-recon-pre-invoice-table__table__link",
                        attrs: { href: "/recon/invoice-detail/" + props.row.id }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(props.row.id) + "\n        "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      label: "Tipo da Fatura",
                      field: "invoice_type",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(props.row.invoice_type.label) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      label: "Transportadora",
                      field: "logistic_provider",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(props.row.logistic_provider) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      label: "Geração",
                      field: "generation_date",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("date")(
                            props.row.generation_date,
                            "DD/MM/YYYY"
                          )
                        ) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      label: "Expiração",
                      field: "expiration_date",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("date")(
                            props.row.expiration_date,
                            "DD/MM/YYYY"
                          )
                        ) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      label: "Qtd. NFs",
                      field: "invoice_count",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(props.row.invoice_count) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      label: "Valor da NF",
                      field: "invoice_value",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("currency")(props.row.invoice_value)) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  { attrs: { label: "Usuário", field: "user", sortable: "" } },
                  [_vm._v("\n        " + _vm._s(props.row.user) + "\n      ")]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75948cd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75948cd6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/invoice/PageInvoice.vue
// module id = null
// module chunks = 